import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const ADMIN_TOKEN_KEY = "pp_admin_token";

export const api = axios.create({
    baseURL: API,
    timeout: 60000,
});

// Attach the admin JWT (if present) to every request — harmless on public routes.
api.interceptors.request.use((config) => {
    const token = sessionStorage.getItem(ADMIN_TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

export const adminLogin = (password) =>
    api.post("/admin/login", { password }).then((r) => r.data);

export const fetchEstimate = (payload) =>
    api.post("/quotes/estimate", payload).then((r) => r.data);

export const submitQuote = (payload) =>
    api.post("/quotes", payload).then((r) => r.data);

export const photoEstimate = (payload) =>
    api.post("/quotes/photo-estimate", payload).then((r) => r.data);

export const listQuotes = () => api.get("/quotes").then((r) => r.data);
export const getQuote = (id) => api.get(`/quotes/${id}`).then((r) => r.data);

export const createDepositCheckout = (payload) =>
    api.post("/payments/checkout", payload).then((r) => r.data);

export const getPaymentStatus = (sessionId) =>
    api.get(`/payments/status/${sessionId}`).then((r) => r.data);

export const setBooking = (quoteId, payload) =>
    api.post(`/quotes/${quoteId}/booking`, payload).then((r) => r.data);

export const refundDeposit = (quoteId) =>
    api.post(`/quotes/${quoteId}/refund`).then((r) => r.data);

export const updateLeadStatus = (quoteId, lead_status) =>
    api.post(`/quotes/${quoteId}/lead-status`, { lead_status }).then((r) => r.data);

export const listShops = () => api.get(`/shops/admin/all`).then((r) => r.data);

export const setShopStatus = (shopId, status) =>
    api.post(`/shops/admin/${shopId}/status`, { status }).then((r) => r.data);
